import Avatar1 from "./images/users/avatar-1.jpg";
import profileImage from "./images/users/avatar-1.jpg";
import logoSm from "./images/logo.png";
import logoDark from "./images/logo.png";
import logoLight from "./images/logo_light.png";
import logoIcon from "./images/favicon.png";
import errorImagesvg from "./images/error.svg";
import defaultprofile from "./images/profile-img-default.png";
import playButton from "./images/play-button.png";
import blankProfile from "./images/blank-profile.webp";
import SigninPageBack from "./images/login.png";
import DefultImage from "./images/DefultImage.png";
import Excel from "./images/excel.png";
const allImages = {
  Excel,
  blankProfile,
  playButton,
  defaultprofile,
  errorImagesvg,
  Avatar1,
  profileImage,
  logoSm,
  logoDark,
  logoLight,
  SigninPageBack,
  DefultImage,
  logoIcon,
};

export default allImages;
